export default __webpack_public_path__ + "static/media/forward-arrow-white.ef959b44.svg";